module.exports = {
      id: "user-usage",
      viewBox: "0 0 158 158",
      url: __webpack_public_path__ + "svg-sprite-fef6f85605acbf641cce7cd75d6011b0.svg#user",
      toString: function () {
        return this.url;
      }
    }